/**
 * @file 添加信用卡
 * @date 2020/07/28
 */

import React, {Component} from 'react';
import NavBarComponent from '../../component/common/NavBarComponent';
import {NavBar, WingBlank, Button, List, InputItem, Icon, Toast} from 'antd-mobile';
import {parseStateToSearch, parseSearchToState} from '../../util/util.js';
import storage from 'store';
import {Http} from '../../api/index';
import './index.scss';

class BindCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // 卡号
            cardNum: '',
            // 预留手机号
            phone: '',
            // 银行编码
            bankCode: '',
            // 银行名称
            orgName: '',
            // 银行代码
            orgCode: '',
            // 卡名
            cardName: '',
            // 卡类型
            cardType: ''
        };
    }

    componentDidMount() {
        this.getUserInfo();
    }

    getUserInfo() {
        const {history} = this.props;
        const search = history.location.search;
        let params = parseSearchToState(search);
        let cardType = {
            CREDIT_CARD: 1,
            DEBIT_CARD: 2
        };
        setTimeout(() => {
            Http.post({url: '/api/cardBinConfig/findMessageByCardNo', data: {
                cardNo: params.cardNum
            }}).then(res => {
                let data = res.data;
                this.setState({
                    // 卡号
                    cardNum: params.cardNum,
                    // 银行编码
                    bankCode: data.bankCode,
                    // 银行名称
                    orgName: data.orgName,
                    // 银行代码
                    orgCode: data.orgCode,
                    // 卡名
                    cardName: data.cardName,
                    // 卡类型
                    cardType: cardType[data.cardType]
                });
            });
        }, 600);
    }

    onChangePhoneNum(val) {
        this.setState({
            phone: val
        });
    }

    submitinfo() {
        let reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
        if (!reg.test(this.state.phone)) {
            return Toast.info('请输入正确手机号码', 1, null, false);
        }
        const {history} = this.props;
        history.push({
            pathname: '/openCard',
            search: parseStateToSearch({
                bankCardNo: this.state.cardNum,
                bankType: this.state.cardType,
                bankCode: this.state.bankCode,
                bankName: this.state.orgName,
                bankPhone: this.state.phone
            })
        });
    }

    render() {
        return (
            <div id="add-card" className="page">
                <NavBarComponent>
                    <NavBar
                        icon={<Icon type="left" color='#333' />}
                        onLeftClick={() => {this.props.history.goBack();}}
                        mode='light'>
                        添加信用卡
                    </NavBar>
                </NavBarComponent>
                <WingBlank>
                    <div className="page-section user-tips">
                        <span className="text">请确认卡类型信息，输入银行预留手机号</span>
                    </div>
                    <div className="page-section">
                        <InputItem value={this.state.orgName}>
                            卡类型
                        </InputItem>
                    </div>
                    <div className="page-section">
                        <List>
                            <InputItem
                                data-type="phone"
                                type="number"
                                maxLength="11"
                                value={this.state.phone}
                                onChange={e => {this.onChangePhoneNum(e);}}
                                placeholder="请输入手机号">
                                请输入手机号
                            </InputItem>
                        </List>
                    </div>
                    <div className="page-section">
                        <Button
                            disabled={this.state.phone.length < 11}
                            type="warning"
                            onClick={e => {this.submitinfo(e);}}>
                            下一步
                        </Button>
                    </div>
                </WingBlank>
            </div>
        );
    }
}

export default BindCard;